/**
 * h5 儿童节模版
 */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { throttle } from 'lodash';
import { updateShareInfo } from '@tencent/h5-share-enhance';
import { isQQ } from '@tencent/h5-env-enhance';
import H5GuestPage from '../../lib/components/Pages/GuestPage';
import { updateCurPageAction } from '../../lib/common/store/reducer/actions';
import style from './index.module.scss';
import AdBanner from '../../lib/components/AdBanner';
import { reportBtnClick, reportPV } from '../../lib/utils/beacon';
import { getQueryParam } from '../../lib/utils';
import { generateCommonData } from '../H5ChristmasIndexPage/h5-config';
const VALID_URL_PREFIX = 'https://act-artifacts.shadowcv.qq.com';
const H5BabyGuestPage = ({ data: { playBtnUrl, backgroundImageUrl, adScrollIcon, adBannerUrl, adBannerBackUrl, adBannerSchema, adBannerGif, guestPageShareMsg, isVideo, shareImageUrl, videoFrameImgUrl, }, meta, global, }) => {
    const dispatch = useDispatch();
    const resUrl = getQueryParam('result', '');
    const posterUrl = getQueryParam('poster', '');
    const adBannerRef = useRef(null);
    const [isAdBannerSeen, setAdBannerSeen] = useState(false);
    const commonData = generateCommonData(global);
    const handleClickPlay = () => {
        dispatch(updateCurPageAction('index'));
    };
    const onScroll = throttle(() => {
        // 至少看到banner10px, 才认为是有效曝光
        const minOffset = 10;
        const distance = adBannerRef.current.getBoundingClientRect().top;
        if (distance > window.innerHeight) {
            setAdBannerSeen(false);
            return;
        }
        if (distance + minOffset <= window.innerHeight && !isAdBannerSeen) {
            setAdBannerSeen(true);
            reportPV('guest#ad-banner');
        }
    }, 500);
    const getShareThumbnailUrl = () => {
        const originUrl = isVideo ? posterUrl : resUrl;
        const thumbnailImageUrl = `${originUrl || shareImageUrl}?imageMogr2/crop/200x200`.replace('act-artifacts.shadowcv.qq.com', 'activity4tlimit-70160.picnjc.qpic.cn');
        return thumbnailImageUrl;
    };
    useEffect(() => {
        // 设置分享链接
        const shareUrl = `https://${window.location.host}${window.location.pathname}?source=link&level=${parseInt(getQueryParam('level', '0'), 10) +
            1}&result=${encodeURIComponent(resUrl)}${isVideo ? `&poster=${encodeURIComponent(posterUrl)}` : ''}`;
        updateShareInfo({
            imgUrl: getShareThumbnailUrl(),
            description: guestPageShareMsg || meta.desc,
            link: shareUrl,
            title: meta.title,
            sourceName: commonData.qqSource,
        });
        onScroll();
    }, []);
    return (React.createElement("div", { ref: adBannerRef, onScroll: onScroll, className: `${style['children-guest-page']} ${isVideo ? '' : style['guest-image']}` },
        React.createElement("img", { src: backgroundImageUrl, alt: "", className: style.bg }),
        React.createElement(H5GuestPage, { isVideo: isVideo, playBtnImgUrl: playBtnUrl, onPlayClick: handleClickPlay, customStyle: style, validateUrl: VALID_URL_PREFIX, resUrl: resUrl, posterUrl: posterUrl, isNeedAutoPlayHiddenBtn: isQQ(), videoFrameImgUrl: videoFrameImgUrl },
            React.createElement(AdBanner, Object.assign({ onClickBanner: () => {
                    reportBtnClick('guest#ad-banner-click');
                }, styleCustom: style }, { adScrollIcon, adBannerSchema, adBannerBackUrl, adBannerUrl, adBannerGif })))));
};
export default H5BabyGuestPage;
